import 'isomorphic-fetch'
import { checkHttpStatus, getApiHeaders, getApiBaseUrlWithOrg } from '../utils'
import { getQuestFilterQuery } from '../utils/quests'
import { getErrorAction } from '../utils/actions'

export const RECEIVE_USER_QUEUE_REQUEST = 'RECEIVE_USER_QUEUE_REQUEST'
export const RECEIVE_USER_QUEUE_SUCCESS = 'RECEIVE_USER_QUEUE_SUCCESS'
export const RECEIVE_USER_QUEUE_FAILURE = 'RECEIVE_USER_QUEUE_FAILURE'
export const SET_SORT = 'SET_SORT'
export const CLEAR_QUESTS = 'CLEAR_QUESTS'

export function receiveUserQueueRequest() {
  return {
    type: RECEIVE_USER_QUEUE_REQUEST
  }
}

export function receiveUserQueueSuccess(response) {
  return {
    type: RECEIVE_USER_QUEUE_SUCCESS,
    payload: {
      quests: response.quests,
      page: response.meta.page,
      total: response.meta.total
    }
  }
}

export function receiveUserQueueFailure(error) {
  return getErrorAction(RECEIVE_USER_QUEUE_FAILURE, error)
}

export function setSort(sort) {
  return {
    type: SET_SORT,
    payload: {
      sort: sort
    }
  }
}

export function clearQuests() {
  return {
    type: CLEAR_QUESTS
  }
}

export function fetchUserAssignments(page, clearQuestsInState) {
  return async (dispatch, getState) => {
    const state = getState()
    const orgId = state.organization.orgId
    const url = `${getApiBaseUrlWithOrg(orgId)}/quests/search`

    if (clearQuestsInState) {
      dispatch(clearQuests())
    }

    const query = getQuestFilterQuery(
      state.queuefilters,
      orgId,
      state.user.user
    )
    dispatch(receiveUserQueueRequest())

    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'POST',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            page: page,
            q: query,
            order: state.queue.sort
          })
        })
      )
      const json = await response.json()
      dispatch(receiveUserQueueSuccess(json))
    } catch (error) {
      dispatch(receiveUserQueueFailure(error))
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/queue.js